import { render, staticRenderFns } from "./Model6.vue?vue&type=template&id=55fffe9c&scoped=true"
import script from "./Model6.vue?vue&type=script&lang=js"
export * from "./Model6.vue?vue&type=script&lang=js"
import style0 from "./Model6.vue?vue&type=style&index=0&id=55fffe9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fffe9c",
  null
  
)

export default component.exports